<template lang="pug">
.reservation-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- ヘッダー：選択
    template(#head(select)="data")
      .d-flex.flex-column
        label(style="margin-left:6px;")
          input(v-model="_allSelect" type="checkbox")
          span.text
    //- ヘッダー：入力、状態
    template(#head(inputTypeAndStatus)="data")
      .d-flex.flex-column
        span 入力
        span 状態
    // ヘッダー：利用者名・部屋名
    template(#head(resident)="data")
      .d-flex.flex-column
        span 利用者名
        span 部屋名
    // ヘッダー：面会者名（続柄）電話番号
    template(#head(familyNameAndTel)="data")
      .d-flex.flex-column
        span 面会者名（続柄）
        span 電話番号
    // ヘッダー：返信
    template(#head(reply)="data")
      .d-flex.flex-row.justify-content-center
        span.help 返信
        HelpIcon(popoverId="reservation-reply-help" title="返信について" placement="bottom")
          template(v-slot:text)
            span 
              strong 未承諾
              span のオンライン面会の予約は、
              strong 「承諾」
              span もしくは
              strong 「辞退」
              span を選択してください。
            br
            span 
              strong 承諾
              span ：予約完了になり、面会者に案内を送信します。
            br
            span
              strong 辞退
              span ：予約辞退となり、面会者に辞退連絡を送信します。
            br
            br
            span 
              strong 承諾済
              span のオンライン面会の予約は、
              strong 「キャンセル」
              span をすることが出来ます。
            br
            span
              strong キャンセル
              span ：予約キャンセルとなり、面会者にキャンセル連絡を送信します。
    // ヘッダー：操作
    template(#head(controll)="data")
      .d-flex.flex-row.justify-content-center
        span.help 操作
        HelpIcon(popoverId="reservation-controll-help" title="操作について" placement="bottom")
          template(v-slot:text)
            span 施設側（利用者側）のオンライン面会の手段に応じて選択することが出来ます。
            br
            br
            strong パソコンの場合
            br
            span
              strong 「面会開始」
              span からオンライン面会（ビデオ通話）を開始することが出来ます。
            br
            br
            strong スマートフォン等の場合
            br
            span
              strong 「案内転送」
              span から施設側のスマートフォンを宛先選択して、案内を送ってください。
              br
              span 案内のリンクからオンライン面会（ビデオ通話）を開始することが出来ます。
              br
              span.font-strong-color 事前に施設関係者の「種類：施設」のグループでスマートフォンをLINE登録をしてください。
              br
              span.font-strong-color 施設関係者の「種類：施設」で登録された施設関係者ユーザーのみ案内転送が出来ます。

    // セル：選択
    template(#cell(select)="row")
      label(v-if="row.item.consented == false && row.item.deleteFlag == false" style="margin-left:6px;")
        input(v-model="row.item.select" type="checkbox")
        span.text
    // セル：種別
    template(#cell(type)="row")
      .d-flex.align-items-center
        .type.center(v-if="row.item.type == 0")
          .icon-offline(title="訪問面会")
        .type.center(v-else)
          .icon-online(title="オンライン面会")
    //- セル：入力、状態
    template(#cell(inputTypeAndStatus)="row")
      .input-type(v-if="row.item.inputType == 0") 代理
      .input-type(v-else) 本人
      .status.status-no-consented(v-if="row.item.consented == false") 未承諾
      .status.status-consented(v-else) 承諾済
    // セル：面会日時
    template(#cell(datetime)="row")
      .d-flex.flex-column
        .date.d-flex.flex-row
          span {{ getDate(row.item.datetime) }}
          span （
          span(:class="weekCssClass(row.item.datetime)") {{ getWeek(row.item.datetime) }}
          span ）
        .time
          span {{ getTime(row.item.datetime) }}
    // セル：面会日時(モーダル)
    template(#cell(modalDatetime)="row")
      span {{ getDate(row.item.datetime) }}
      span （
      span(:class="weekCssClass(row.item.datetime)") {{ getWeek(row.item.datetime) }}
      span ）
      span {{ getTime(row.item.datetime) }}
    //- セル：面会場所
    template(#cell(location)="row")
      .d-flex.flex-row(v-if="row.item.type == 0")
        .text-content.flex-fill
          span(:id="`location-${row.item.id}`") {{ row.item.location }}
          b-popover(:target="`location-${row.item.id}`" triggers="hover" :placement="'bottomright'")
            span(style="white-space: pre-wrap; word-wrap: break-word;") {{ row.item.location }}
        .mr-1
        .button(v-if="showLocationEdit(row.item)")
          .edit-text(@click.stop="onEditLocation(row.item)" title="面会場所を編集します")
    // セル：利用者名
    template(#cell(resident)="row")
      .d-flex.flex-column(:id="`resident-${row.item.id}`")
        span.resident {{ row.item.resident.name }}
        span.resident {{ row.item.resident.room }}
      b-popover(v-if="row.item.resident.name" :target="`resident-${row.item.id}`" triggers="hover" :placement="'bottomright'")
        .d-flex.flex-column
          div.font-weight-bold 利用者グループ
          div {{ row.item.groupName }}
          div.font-weight-bold 部屋名
          div {{ row.item.resident.room }}
          div.font-weight-bold 利用者名
          div {{ row.item.resident.name }}
    // セル：利用者名(モーダル)
    template(#cell(modalResident)="row")
      .d-flex.flex-column(:id="`resident-${row.item.id}`")
        span.resident {{ row.item.resident.name }}（{{ row.item.resident.room }}）
    // セル：面会者名（続柄）電話番号
    template(#cell(familyNameAndTel)="row")
      .d-flex.flex-column
        span.family(:id="`family-${row.item.id}`") {{ row.item.family.name }}（{{ row.item.family.relation }}）
        b-popover(v-if="row.item.resident.name" :target="`family-${row.item.id}`" triggers="hover" :placement="'bottomright'")
          .d-flex.flex-column
            div.font-weight-bold 家族名
            div {{ row.item.family.name }}
            div.font-weight-bold 続柄
            div {{ row.item.family.relation ? row.item.family.relation: "未入力" }}
            div.font-weight-bold 役割
            div {{ row.item.resident.position ? row.item.resident.position : "未入力" }}
        span {{ row.item.tel }}
    // セル：面会者名（続柄）(モーダル)
    template(#cell(modalFamilyName)="row")
      .d-flex.flex-column
        span.family(:id="`family-${row.item.id}`") {{ row.item.family.name }}（{{ row.item.family.relation }}）
    // セル：連絡事項
    template(#cell(text)="row")
      .d-flex.flex-row
        .text-content.flex-fill
          span(:id="`text-${row.item.id}`") {{ row.item.text }}
          b-popover(:target="`text-${row.item.id}`" triggers="hover" :placement="'bottomright'")
            span(style="white-space: pre-wrap; word-wrap: break-word;") {{ row.item.text }}
        .mr-1
        .button(v-if="row.item.deleteFlag == false")
          .edit-text(@click.stop="onEditText(row.item)" title="連絡事項を編集します")
    // セル：返信ボタン
    template(#cell(reply)="row")
      .reply(v-if="row.item.deleteFlag == false")
        .center(v-if="row.item.consented == false")
          template(v-if="!_useEditReservations")
            button.btn.consented-btn.disable(disabled) 承諾
            button.btn.disable(disabled) 辞退
          template(v-else)
            button.btn.consented-btn(@click="onConsented(row.item)") 承諾
            button.btn(@click="onUnconsented(row.item)") 辞退
        .center(v-else)
          button.btn.cancel-btn.disable(v-if="!_useEditReservations" disabled) キャンセル
          button.btn.cancel-btn(v-else @click="onConsentedCancel(row.item)") キャンセル
    // セル：操作ボタン
    template(#cell(controll)="row")
      .controll.center(v-if="row.item.type == 0")
      .controll.center(v-else-if="row.item.consented == false")
        button.btn.online-url.disable(disabled) 面会開始
        button.btn.send-other.disable(disabled) 案内転送
      .controll.center(v-else)
        template(v-if="_useStartOnlineReservations && _useEditReservations")
          button.btn.online-url(@click="onOnlineUrl(row.item)") 面会開始
          template(v-if="2 <= _planType")
            button.btn.send-other(@click="onSendOther(row.item)") 案内転送
          template(v-else)
            button.btn.send-other.disable(disabled) 案内転送
        template(v-if="_useStartOnlineReservations && !_useEditReservations")
          button.btn.online-url(@click="onOnlineUrl(row.item)") 面会開始
          button.btn.send-other.disable(disabled) 案内転送
        template(v-if="!_useStartOnlineReservations && _useEditReservations")
          button.btn.online-url.disable(disabled) 面会開始
          template(v-if="2 <= _planType")
            button.btn.send-other(@click="onSendOther(row.item)") 案内転送
          template(v-else)
            button.btn.send-other.disable(disabled) 案内転送
        template(v-if="!_useStartOnlineReservations && !_useEditReservations")
          button.btn.online-url.disable(disabled) 面会開始
          button.btn.send-other.disable(disabled) 案内転送
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import { PlanType } from "@/commons/services/Plans";
import { ReservationSettingsGetModel } from "@/commons/services/ReservationSettings";

/**
 * 予約テーブルコンポーネント
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class ReservationTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ReservationTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ReservationTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: any;
  /** 全て選択列のチェック */
  @Prop()
  allSelect!: boolean;
  /** 訪問面会設定 */
  @Prop()
  visitSetting!: ReservationSettingsGetModel;

  get _value(): Array<ReservationTableItem> {
    return this.value;
  }

  get _useEditReservations(): boolean {
    return userStore.user.permissions.reservationsFunction.useEditReservations;
  }

  get _useStartOnlineReservations(): boolean {
    return userStore.user.permissions.reservationsFunction.useStartOnlineReservations;
  }

  get _planType(): PlanType {
    return userStore.facility.planType;
  }

  get _allSelect(): boolean {
    return this.allSelect;
  }

  set _allSelect(newValue: boolean) {
    this.$emit("update:allSelect", newValue);
    this.$emit("onAllSelect");
    return;
  }

  /**
   * 日付(yyyy年mm月dd日)を返す
   * */
  public getDate(date: number): string {
    return this.$dateUtil.convertNumberToString(date, "mm月dd日");
  }

  /**
   * 曜日を返す
   */
  public getWeek(date: number): string {
    const dateObject: Date = this.$dateUtil.convertNumberToDate(date);
    return this.$dateUtil.getWeekName(dateObject, "ja");
  }

  /**
   * 曜日の文字色CssClassの割り当て
   */
  public weekCssClass(date: number): string {
    let weekClassName: string = "";
    const weekName: string = this.getWeek(date);
    switch (weekName) {
      case "日":
        weekClassName = "sunday";
        break;
      case "土":
        weekClassName = "saturday";
        break;
      default:
        break;
    }

    return weekClassName;
  }

  /**
   * 時分を返す
   */
  public getTime(date: number): string {
    return this.$dateUtil.convertNumberToString(date, "hh:MM");
  }

  /** 面会場所の編集ボタンを表示するか否か */
  showLocationEdit(item: ReservationTableItem): boolean {
    if (item.deleteFlag) {
      return false;
    }
    if (this.visitSetting && this.visitSetting.useLocation) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### フィルタリング
   */
  public filterTable(item: ReservationTableItem, filter: FilterSetting): boolean {
    return this.filterGroupId(item, filter) && this.filterSearchWords(item, filter) && this.filterDeleted(item, filter);
  }

  public filterGroupId(item: ReservationTableItem, filter: FilterSetting): boolean {
    if (filter.id == "") {
      return true;
    }

    if (item.groupId == Number(filter.id)) {
      return true;
    } else {
      return false;
    }
  }

  public filterSearchWords(item: ReservationTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundResidentName: boolean = true;
    let foundResidentKanaName: boolean = true;
    let foundRoom: boolean = true;
    let foundFamilyName: boolean = true;

    for (const word of words) {
      // 利用者
      if (item.resident.name.indexOf(word) == -1) {
        foundResidentName = false;
      }

      // 利用者（ふりがな）
      if (item.resident.kanaName) {
        if (item.resident.kanaName.indexOf(word) == -1) {
          foundResidentKanaName = false;
        }
      } else {
        foundResidentKanaName = false;
      }

      // 部屋名
      if (item.resident.room.indexOf(word) == -1) {
        foundRoom = false;
      }

      // 家族名
      if (item.family.name.indexOf(word) == -1) {
        foundFamilyName = false;
      }
    }

    return foundResidentName || foundResidentKanaName || foundRoom || foundFamilyName;
  }

  public filterDeleted(item: ReservationTableItem, filter: FilterSetting): boolean {
    // 削除済を表示する場合、全レコードを表示させる
    if (filter.showCanceled == true) {
      return true;
    }
    // 削除済を表示しない場合、削除されていないレコードのみを表示させる
    else {
      if (item.deleteFlag == false) {
        return true;
      } else {
        return false;
      }
    }
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 全て選択押下イベント
   */
  public onAllSelect(): void {
    this.$emit("onAllSelect");
    return;
  }

  /**
   * ### 面会場所の編集ボタン押下イベント
   */
  onEditLocation(item: ReservationTableItem): void {
    this.$emit("onEditLocation", item);
    return;
  }

  /**
   * ### 連絡事項の編集ボタン押下イベント
   */
  onEditText(item: ReservationTableItem): void {
    this.$emit("onEditText", item);
    return;
  }

  /**
   * ### 承諾ボタン押下イベント処理
   *
   * - 親コンポーネントに承諾されたことを通知する
   */
  public onConsented(item: ReservationTableItem): void {
    this.$emit("onConsented", item);
    return;
  }

  /**
   * ### 辞退ボタン押下イベント処理
   *
   * - 親コンポーネントに辞退されたことを通知する
   */
  public onUnconsented(reservation: ReservationTableItem): void {
    this.$emit("onUnconsented", reservation);
    return;
  }

  /**
   * ### キャンセルボタン押下イベント処理
   *
   * - 親コンポーネントにキャンセルされたことを通知する
   */
  public onConsentedCancel(reservation: ReservationTableItem): void {
    this.$emit("onConsentedCancel", reservation);
    return;
  }

  /**
   * ### オンライン面会を別タブで起動する
   */
  public onOnlineUrl(reservation: ReservationTableItem): void {
    window.open(reservation.onlineVisitUrl, "_blank");
    return;
  }

  /**
   * ### URLを転送するために宛先選択ダイアログを表示する
   */
  public onSendOther(reservation: ReservationTableItem): void {
    this.$emit("onSendOther", reservation);
    return;
  }
}

/** テーブルの列名の情報 */
export interface ReservationTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ReservationTableItem {
  id: number;
  type: number;
  consented: boolean;
  inputType: number;
  datetime: number;
  resident: { id: number; name: string; kanaName: string; room: string };
  family: { name: string; relation: string; id: number; position: string };
  /** 面会場所 */
  location: string;
  tel: string;
  text: string;
  status: boolean;
  onlineVisitUrl?: string;
  updated: number;
  groupId: number;
  groupName: string;
  deleteFlag: boolean;
  /** 選択 */
  select: boolean;
  /** 行単位の設定値 */
  _rowVariant?: string;
}

export interface FilterSetting {
  id: string;
  searchWord: string;
  showCanceled: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.reservation-table-component {
  .icon-offline {
    @include svg-icon("../../../assets/reservation/offline.svg", $font-base-color);
  }
  .icon-online {
    @include svg-icon("../../../assets/reservation/online.svg", $font-base-color);
  }

  .status-consented {
    color: $font-disable-font-color;
    font-weight: bold;
  }
  .status-no-consented {
    color: $font-strong-color;
    font-weight: bold;
  }
  .family {
    font-weight: bold;
  }
  .consented-btn {
    margin-right: 5px;
  }
  .online-url {
    margin-right: 5px;
  }
  .help {
    margin-right: 4px;
  }

  ::v-deep {
    .reply {
      min-width: 100px;
      width: 100px;
    }
    .controll {
      min-width: 154px;
      width: 154px;
    }

    td.small-buttons {
      .reply,
      .controll {
        .cancel-btn {
          width: 96px;
        }
        button.btn {
          height: 32px !important;
          font-size: 14px !important;
          padding: 2px 8px !important;
        }
      }
    }
  }

  .edit-text {
    @include svg-icon("../../../assets/pen.svg", $font-base-color, 16px, 16px);
    opacity: 0.5;
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
  }
  .edit-text:hover {
    opacity: 0.75;
  }
}
</style>
